module.exports = __webpack_public_path__ + "b6f32d26438a42219472cc672b278503.pdf";